/* eslint-disable import/no-unresolved */
import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import {Typography,Box , Grid} from '@material-ui/core';
import footerStyle from "../jss/footerStyle";
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({ ...footerStyle(theme) }));

export default function StickyFooter() {
  const classes = useStyles();
  const [openTerms, setOpenTerms] = useState(false);

  const onClickTerms = (e) => {
      e.preventDefault();

      setOpenTerms(!openTerms);
  };

  return (
    <footer className={clsx (classes.footer, "footer-setting")}>
      <Container >
      <Grid container >
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Box className="footer-main">
      <Box fontSize= "15px" paddingTop="10px" paddingBottom="10px" marginLeft="5px">Calculadoras De Apostas Esportivas © Direito Autoral Apostapedia <span className="terms-conditions"> <Link href="#" onClick={onClickTerms} className="terms-setting">
            Termos {"&"} Condições
        </Link>
        </span></Box>
       </Box>
        <div style={{ display: openTerms ? 'inline-block' : 'none' }}>
            <Divider />
            <Typography variant="body2">Apostapedia.pt exime-se de qualquer responsabilidade relativamente ao conteúdo destas calculadoras e a qualquer utilização das mesmas que possa ser feita por qualquer pessoa. Apostapedia.pt não faz quaisquer representações ou garantias, expressas ou implícitas, quanto à exatidão, integridade ou adequação a qualquer finalidade ou utilização do conteúdo fornecido. Conseqüentemente, você não deve confiar em nenhuma informação como oficial ou como um substituto para o exercício de sua própria habilidade e julgamento ao tomar uma negociação ou outra decisão. <a href="https://apostapedia.pt/br/multi-calculator-license-agreement/">Contrato de licença</a></Typography>
        </div>
			</Grid>
      
      </Grid>
      
      </Container>
    </footer>
  );
}
